module.exports = require("./sn.d.ts");